<template>
  <div class="o-card">
    <div class="row u-justify-content-space-between">
      <div
        class="es-xs-12"
        :class="{ 'es-lg-6': creatingPdf, 'es-lg-7': !creatingPdf }"
      >
        <h4>
          # {{ cycle.serialNumber }}
          <Button
            v-if="!creatingPdf"
            size="sm"
            variant="light-danger"
            @click="$emit('create:pdf')"
          >
            <i class="icofont-file-pdf"></i> {{ $t("common.print") }}
          </Button>
        </h4>
        <div class="u-margin-top-xsmall">
          <strong>{{ $t("cyclesForm.project") }}:</strong>
          <router-link
            :to="{
              name: 'project-detail',
              params: { projectId: cycle.projectInfo.id },
            }"
          >
            {{ cycle.projectInfo.model }}
          </router-link>
          <strong class="u-margin-left-xsmall">
            {{ $t("cyclesForm.refrigerant") }}:</strong
          >
          {{ cycle.refrigerantInfo.title }}
        </div>
        <h5 class="u-margin-top-xsmall u-color-primary">
          {{ cycle.userInfo.fullname }} - {{ $date.format(cycle.createdDate) }}
        </h5>
        <div v-if="!creatingPdf" class="u-margin-top-small">
          <Button
            @click="cycle.isPermission && (lockedModal.status = true)"
            :disabled="!cycle.isPermission"
            class="u-margin-right-xsmall"
            :variant="cycle.isLocked ? 'light-danger' : 'light-success'"
          >
            <i :class="`icofont-ui-${cycle.isLocked ? '' : 'un'}lock`"></i>
            {{
              cycle.isLocked
                ? $t("common.lockedText")
                : $t("common.unlockedText")
            }}
          </Button>
          <Button
            :disabled="!cycle.isPermission || cycle.isLocked"
            @click="
              (cycle.isPermission || cycle.isLocked) &&
                (removeModal.status = true)
            "
            variant="light-danger"
          >
            <i
              :class="`icofont-${
                cycle.isPermission && !cycle.isLocked ? 'trash' : 'ui-lock'
              } u-margin-right-xsmall`"
            ></i>
            {{ $t("common.remove") }}
          </Button>
        </div>
      </div>
      <div class="es-xs-12 es-lg-6 u-text-align-right" v-if="creatingPdf">
        <div class="u-background-color-white o-card__padding-small">
          <div>
            <strong>{{ $t("cyclesForm.compressor") }}:</strong>
            <span>
              {{ cycle.cycleCalculateValueInfo.compressorQuantity }}
              {{ $t("common.pcs") }}
              {{ cycle.cycleCalculateValueInfo?.compressorBrandInfo?.title }}
            </span>
          </div>
          <div>
            <span>
              {{
                cycle.cycleCalculateValueInfo?.compressorBrandRefrigerantInfo
                  ?.title
              }}
              -
              {{
                cycle.cycleCalculateValueInfo?.compressorRefrigerantModelInfo
                  ?.title
              }}
            </span>
          </div>
          <div>
            <strong> {{ $t("cyclesForm.constantAirFlowRate") }}:</strong>
            {{
              $t(`common.${cycle.cycleCalculateValueInfo.constantAirFlowRate}`)
            }}
          </div>
          <div>
            <strong>{{ $t("cyclesForm.variableAirFlowRate") }}:</strong>
            {{
              $t(`common.${cycle.cycleCalculateValueInfo.variableAirFlowRate}`)
            }}
          </div>
        </div>
      </div>
      <div v-else class="es-xs-12 es-lg-5">
        <CoolingCapacity
          ref="coolingCapacity"
          @request="CalculateCycle"
          :model="cycle.projectInfo.model"
          :refrigerants="cycle.refrigerantInfo.id"
        ></CoolingCapacity>
      </div>
    </div>
    <LockedModal
      v-model="lockedModal.status"
      :description="$t(`updateCycles.${SET_LOCKED_DESCRIPTION()}`)"
      :okText="$t(`common.${SET_LOCKED_DESCRIPTION()}`)"
      @ok="LOCKED_ITEM"
    ></LockedModal>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
  </div>
</template>

<script>
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import LockedModal from "@/components/Shared/LockedModal/index.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import CoolingCapacity from "../Cycles/CycleForm/CoolingCapacity.vue";

export default {
  name: "ActionBar",
  components: {
    Button,
    LockedModal,
    RemoveModal,
    CoolingCapacity,
  },
  data() {
    return {
      lockedModal: {
        status: false,
      },
      removeModal: {
        status: false,
      },
    };
  },
  props: {
    cycle: {
      default: () => ({}),
    },
    creatingPdf: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    setForm(cycleItem = {}) {
      return {
        projectId: this.cycle.projectInfo.id,
        refrigerantId: this.cycle.refrigerantInfo.id,
        superheat: this.cycle.superheat,
        subcooling: this.cycle.subcooling,
        condensingTemp: this.cycle.cycleCalculateValueInfo.condensingTemp,
        condenserFanFlow: this.cycle.condenserFanFlow,
        condenserAirInletTemp: this.cycle.condenserAirInletTemp,
        condenserAirInletHumidity: this.cycle.condenserAirInletHumidity,
        evaporatorAirInletTemp: this.cycle.evaporatorAirInletTemp,
        evaporatorAirInletHumidity: this.cycle.evaporatorAirInletHumidity,
        evaporatorFanFlow: this.cycle.evaporatorFanFlow,
        evapBatteryId: this.cycle.evaporatorBatteryInfo.id,
        condBatteryId: this.cycle.condenserBatteryInfo.id,
        evapQuantity: this.cycle.cycleCalculateValueInfo.evapQuantity,
        condQuantity: this.cycle.cycleCalculateValueInfo.condQuantity,
        compressorBrandId:
          this.cycle.cycleCalculateValueInfo.compressorBrandInfo.id,
        compressorRefrigerantId:
          this.cycle.cycleCalculateValueInfo.compressorBrandRefrigerantInfo.id,
        compRefrigetantModelId:
          this.cycle.cycleCalculateValueInfo.compressorRefrigerantModelInfo.id,
        compressorQuantity:
          this.cycle.cycleCalculateValueInfo.compressorQuantity,
        constantAirFlowRate:
          this.cycle.cycleCalculateValueInfo.constantAirFlowRate,
        variableAirFlowRate:
          this.cycle.cycleCalculateValueInfo.variableAirFlowRate,
        evapAbsoluteFlowDifference: 1,
        condAbsoluteFlowDifference: 1,
        ...cycleItem,
      };
    },
    async CalculateCycle(results, callback, withHavaDebili) {
      this.$refs.coolingCapacity.showLoadingModal = true;
      const response = await Requests.Cycle.CalculateMultipleCycle({
        ...this.setForm(),
        multipleCalculateCycleRequest: results,
        withHavaDebili,
      });
      if (response.message === "OK") {
        callback(response.data, "success", withHavaDebili);
      } else {
        callback(response, "error", withHavaDebili);
      }
    },
    SET_LOCKED_DESCRIPTION() {
      return this.cycle.isLocked ? "unlocked" : "locked";
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await this.$store.dispatch("removeCycle", {
        id: this.cycle.id,
      });
      if (response.message === "OK") {
        this.$router.push({ name: "cycles" });
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`removeCycles.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`removeCycles.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async LOCKED_ITEM(loading) {
      loading(true);
      const response = await Requests.Cycle.UpdateLockStatus(
        { params: { id: this.cycle.id } },
        { isLocked: !this.cycle.isLocked }
      );
      if (response.message === "OK") {
        this.$emit("refresh");
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateBatteries.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateBatteries.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
};
</script>

<style></style>
